import React from "react";
import {
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
} from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import { Btn } from "../../../AbstractElements";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import { toast } from "react-toastify";
import { NumericFormat } from "react-number-format";

export const DataByCountryForm = ({
  aditionalData,
  setAditionalData,
  handleRemoveCountry,
}) => {
  const { getData } = useDataFetch();
  const { data: dataCountries } = getData(
    ["countries"],
    "/product/countries-available/all"
  );

  const {
    control,
    handleSubmit,
    trigger,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      country_id: "",
      currency: "",
      price_local_currency: "",
      price_usdt: "",
      delivery_time_days: "",
      loyalty_points: "",
      influencer_bonus: "",
    },
  });

  const onSubmit = async (data) => {
    const exists = aditionalData.some(
      (item) => item.country_id === data.country_id
    );
    if (exists) {
      toast.error("Este país ya fue agregado.");
      return;
    }

    setAditionalData([...aditionalData, data]);
    toast.success("País agregado correctamente.");
    reset();
  };

  const renderCurrencyInput = (field, name) => (
    <NumericFormat
      {...field}
      className="form-control"
      thousandSeparator="."
      decimalSeparator=","
      prefix="$ "
      decimalScale={2}
      fixedDecimalScale={true}
      allowNegative={false}
      onValueChange={(values) => {
        field.onChange(values.floatValue);
      }}
      onBlur={() => trigger(name)}
    />
  );

  return (
    <Col xxl="7">
      <Card className="h-100">
        <CardBody style={{ maxHeight: "600px", overflowY: "auto" }}>
          <h5>Datos por país</h5>
          <Row className="g-2">
            <Col md="6">
              <FormGroup>
                <Label>País</Label>
                <Controller
                  name="country_id"
                  control={control}
                  rules={{ required: "Selecciona un país" }}
                  render={({ field }) => (
                    <Input
                      type="select"
                      {...field}
                      onChange={(e) => {
                        field.onChange(e.target.value);
                        const selected = dataCountries?.data?.countries.find(
                          (c) => c.id === e.target.value
                        );
                        if (selected) {
                          setValue("currency", selected.currency || "");
                        }
                      }}
                      onBlur={() => trigger("country_id")}
                    >
                      <option value="">Selecciona</option>
                      {dataCountries?.data?.countries.map((country) => (
                        <option key={country.id} value={country.id}>
                          {country.name}
                        </option>
                      ))}
                    </Input>
                  )}
                />
                {errors.country_id && (
                  <span className="text-danger small">
                    {errors.country_id.message}
                  </span>
                )}
              </FormGroup>
            </Col>

            <Col md="6">
              <FormGroup>
                <Label>Moneda local</Label>
                <Controller
                  name="currency"
                  control={control}
                  render={({ field }) => (
                    <Input {...field} type="text" readOnly disabled />
                  )}
                />
              </FormGroup>
            </Col>

            <Col md="6">
              <FormGroup>
                <Label>Precio Local</Label>
                <Controller
                  name="price_local_currency"
                  control={control}
                  rules={{
                    required: "Campo obligatorio",
                    min: { value: 0, message: "Debe ser >= 0" },
                  }}
                  render={({ field }) =>
                    renderCurrencyInput(field, "price_local_currency")
                  }
                />
                {errors.price_local_currency && (
                  <span className="text-danger small">
                    {errors.price_local_currency.message}
                  </span>
                )}
              </FormGroup>
            </Col>

            <Col md="6">
              <FormGroup>
                <Label>Precio USDT</Label>
                <Controller
                  name="price_usdt"
                  control={control}
                  rules={{
                    required: "Campo obligatorio",
                    min: { value: 0, message: "Debe ser >= 0" },
                  }}
                  render={({ field }) =>
                    renderCurrencyInput(field, "price_usdt")
                  }
                />
                {errors.price_usdt && (
                  <span className="text-danger small">
                    {errors.price_usdt.message}
                  </span>
                )}
              </FormGroup>
            </Col>

            <Col md="6">
              <FormGroup>
                <Label>Regalía</Label>
                <Controller
                  name="loyalty_points"
                  control={control}
                  rules={{
                    required: "Campo obligatorio",
                    min: { value: 0, message: "Debe ser >= 0" },
                  }}
                  render={({ field }) => (
                    <Input
                      type="number"
                      {...field}
                      onBlur={() => trigger("loyalty_points")}
                    />
                  )}
                />
                {errors.loyalty_points && (
                  <span className="text-danger small">
                    {errors.loyalty_points.message}
                  </span>
                )}
              </FormGroup>
            </Col>

            <Col md="6">
              <FormGroup>
                <Label>Bono influencer</Label>
                <Controller
                  name="influencer_bonus"
                  control={control}
                  rules={{
                    required: "Campo obligatorio",
                    min: { value: 0, message: "Debe ser >= 0" },
                  }}
                  render={({ field }) => (
                    <Input
                      type="number"
                      {...field}
                      onBlur={() => trigger("influencer_bonus")}
                    />
                  )}
                />
                {errors.influencer_bonus && (
                  <span className="text-danger small">
                    {errors.influencer_bonus.message}
                  </span>
                )}
              </FormGroup>
            </Col>

            <Col md="6">
              <FormGroup>
                <Label>Días de entrega</Label>
                <Controller
                  name="delivery_time_days"
                  control={control}
                  rules={{
                    required: "Campo obligatorio",
                    min: { value: 0, message: "Debe ser >= 0" },
                  }}
                  render={({ field }) => (
                    <Input
                      type="number"
                      {...field}
                      onBlur={() => trigger("delivery_time_days")}
                    />
                  )}
                />
                {errors.delivery_time_days && (
                  <span className="text-danger small">
                    {errors.delivery_time_days.message}
                  </span>
                )}
              </FormGroup>
            </Col>

            <Col md="12" className="text-end">
              <Btn
                attrBtn={{
                  color: "info",
                  size: "sm",
                  type: "button",
                  onClick: handleSubmit(onSubmit),
                }}
              >
                <i className="fa fa-plus me-2"></i> Agregar país
              </Btn>
            </Col>
          </Row>

          <div className="mt-3">
            <h6>Países agregados</h6>
            <Table bordered responsive size="sm">
              <thead className="table-light">
                <tr>
                  <th>País</th>
                  <th>Moneda Local</th>
                  <th>Precio Local</th>
                  <th>USDT</th>
                  <th>Días Entrega</th>
                  <th>Regalía</th>
                  <th>Bono</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {aditionalData.length === 0 ? (
                  <tr>
                    <td colSpan={7} className="text-center text-muted">
                      No hay países agregados.
                    </td>
                  </tr>
                ) : (
                  aditionalData.map((item, idx) => {
                    const country = dataCountries?.data?.countries.find(
                      (c) => c.id === item.country_id
                    );
              
                    return (
                      <tr key={idx}>
                        <td>{country?.name ?? "N/A"}</td>
                        <td>{item.currency}</td>
                        <td>{item.price_local_currency}</td>
                        <td>{item.price_usdt}</td>
                        <td>{item.delivery_time_days}</td>
                        <td>{item.loyalty_points}</td>
                        <td>{item.influencer_bonus}</td>
                        <td>
                          <Btn
                            attrBtn={{
                              color: "danger",
                              size: "sm",
                              type: "button",
                              onClick: () => handleRemoveCountry(idx),
                            }}
                          >
                            <i className="fa fa-trash"></i>
                          </Btn>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
